var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mp_login.is_available == 1 && _vm.$pub.isWeiXin()&&_vm.websiteUnUseWx)?_c('div',{staticClass:"otherLogin"},[_c('p',[_vm._v("第三方登录")]),_c('div',{staticClass:"txLogin"},[_c('div',{staticClass:"wxLogin",on:{"click":_vm.otherLogin}},[_c('img',{attrs:{"src":require("@/assets/images/wechat.png")}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }